import { useState } from "react";
import { Form, Modal } from "react-bootstrap"
import { useNavigate } from "react-router-dom";
import ButtonClose from "./ButtonClose";

const ModalActivarCuenta = (props) => {

    const handleClose = () => props.close(false)

    const navigate = useNavigate()

    const [form, setForm] = useState({
        rfc: '',
        celular: '',
        email: ''
    })

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    const handleSubmit = () => {
        navigate('/ecosistema')
    }

    return (
        <>
            <Modal show={props.show} onHide={handleClose} className='modal__activa-cuenta' tabIndex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true" >
                <Modal.Header>
                    <ButtonClose close={handleClose} />
                </Modal.Header>
                <Modal.Body className='p-0'>
                    <div className='col-12'>
                        <h1 className='modal__activa-cuenta__title text-center mb-5'>¡Activar tu cuenta es muy sencillo!</h1>
                    </div>
                    <div className='col-12 modal__activa-cuenta__body'>
                        <p>Complete los datos a continuación para comenzar a activar su cuenta:</p>
                        <Form autoComplete="off" onSubmit={(e) => { e.preventDefault()}} className="form__modal" >
                            <div className="row justify-content-center">
                                <div className='col-12'>
                                    <input
                                        type='text'
                                        className='form-control border-input '
                                        id='rfc'
                                        name='rfc'
                                        placeholder='RFC'
                                        autoComplete="off"
                                        value={form.rfc}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className='col-12'>
                                    <input
                                        type='text'
                                        className='form-control border-input '
                                        id='celular'
                                        name='celular'
                                        placeholder='Celular'
                                        autoComplete="off"
                                        value={form.celular}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className='col-12'>
                                    <input
                                        type='text'
                                        className='form-control border-input '
                                        id='email'
                                        name='email'
                                        placeholder='E-mail'
                                        autoComplete="off"
                                        value={form.email}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className='col-12 mt-5 mb-5 pb-5'>
                                    <input type="checkbox" className="activa__checkbox" />
                                    <label className="activa__label">He leído y acepto las condiciones de uso.</label>
                                </div>
                                <div className='col-12 mt-5 pt-5'>
                                    <button className="btn__azul" onClick={handleSubmit}>CONTINUAR</button>
                                </div>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalActivarCuenta